import { action, observable } from 'mobx';

interface IPasswordDataStore {
    [key: string]: string;
}

export class PasswordRepository {
    @observable public passwordDataStore: IPasswordDataStore = {};

    @action
    public updatePassword = (fieldValue: string, fieldName: string) => {
        this.passwordDataStore[fieldName] = fieldValue;
    };
}
